require('../../modules/es6.number.parse-float');
module.exports = parseFloat;


//////////////////
// WEBPACK FOOTER
// /Users/kevinmircovich/node_modules/core-js/library/fn/number/parse-float.js
// module id = NE1x
// module chunks = 1